import { cgwClient as api } from '../cgwClient'
export const addTagTypes = ['relay'] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      spaceRelayRelayV1: build.mutation<SpaceRelayRelayV1ApiResponse, SpaceRelayRelayV1ApiArg>({
        query: (queryArg) => ({
          url: `/v1/spaces/${queryArg.spaceId}/chains/${queryArg.chainId}/relay`,
          method: 'POST',
          body: queryArg.spaceRelayDto,
        }),
        invalidatesTags: ['relay'],
      }),
      relayRelayV1: build.mutation<RelayRelayV1ApiResponse, RelayRelayV1ApiArg>({
        query: (queryArg) => ({ url: `/v1/chains/${queryArg.chainId}/relay`, method: 'POST', body: queryArg.relayDto }),
        invalidatesTags: ['relay'],
      }),
      relayGetTaskStatusV1: build.query<RelayGetTaskStatusV1ApiResponse, RelayGetTaskStatusV1ApiArg>({
        query: (queryArg) => ({ url: `/v1/chains/${queryArg.chainId}/relay/status/${queryArg.taskId}` }),
        providesTags: ['relay'],
      }),
      relayGetRelaysRemainingV1: build.query<RelayGetRelaysRemainingV1ApiResponse, RelayGetRelaysRemainingV1ApiArg>({
        query: (queryArg) => ({
          url: `/v1/chains/${queryArg.chainId}/relay/${queryArg.safeAddress}`,
          params: {
            safeTxHash: queryArg.safeTxHash,
          },
        }),
        providesTags: ['relay'],
      }),
    }),
    overrideExisting: false,
  })
export { injectedRtkApi as cgwApi }
export type SpaceRelayRelayV1ApiResponse = /** status 201 Transaction relayed */ Relay
export type SpaceRelayRelayV1ApiArg = {
  /** Chain ID where the Safe transaction will be executed */
  chainId: string
  /** Space UUID */
  spaceId: string
  spaceRelayDto: SpaceRelayDto
}
export type RelayRelayV1ApiResponse = /** status 200 Transaction relayed successfully */ Relay
export type RelayRelayV1ApiArg = {
  /** Chain ID where the Safe transaction will be executed */
  chainId: string
  /** Transaction data to relay. safeTxHash is required on relay-fee chains and must correspond to the to + data fields. Set acceptUnverifiedSimulation=true to retry a relay skipping the simulation which previously returned INDETERMINATE_SIMULATION. */
  relayDto: RelayDto
}
export type RelayGetTaskStatusV1ApiResponse = /** status 200 Task status retrieved successfully */ RelayTaskStatus
export type RelayGetTaskStatusV1ApiArg = {
  /** Chain ID associated with the relay task */
  chainId: string
  /** Task ID returned from the relay transaction */
  taskId: string
}
export type RelayGetRelaysRemainingV1ApiResponse =
  /** status 200 Remaining relay quota retrieved successfully */ RelaysRemaining
export type RelayGetRelaysRemainingV1ApiArg = {
  /** Chain ID where the Safe is deployed */
  chainId: string
  /** Safe contract address (0x prefixed hex string) */
  safeAddress: string
  /** Safe transaction hash (0x prefixed hex string). Ignored; kept so existing clients do not break. */
  safeTxHash?: string
}
export type Relay = {
  taskId: string
}
export type GasPaymentOptionUnavailableResponse = {
  code: 'GAS_PAYMENT_OPTION_UNAVAILABLE'
  /** Human-readable description of the error. Informational only; do not parse. */
  message: string
  statusCode: number
  /** The gas payment option the request needed. */
  requested: 'FREE_DAILY_LIMIT' | 'SUBSCRIPTION' | 'PAY_FROM_SAFE' | 'NO_FEE_CAMPAIGN'
  /** NOT_LISTED: the chain does not list the option. NO_RELAYER: the chain has no relayer. NOT_A_WORKSPACE_SAFE: the Safe is not one the workspace holds. REFUNDING_TRANSACTION: the transaction would refund gas (`gasPrice` > 0). */
  reason: 'NOT_LISTED' | 'NO_RELAYER' | 'NOT_A_WORKSPACE_SAFE' | 'REFUNDING_TRANSACTION'
  /** The options the chain lists; empty without a relayer. */
  available: ('FREE_DAILY_LIMIT' | 'SUBSCRIPTION' | 'PAY_FROM_SAFE' | 'NO_FEE_CAMPAIGN')[]
}
export type SpaceRelayDto = {
  version: string
  to: string
  data: string
  /** Safe transaction hash, forwarded to the relay provider for traceability. Not verified against the calldata on this route. */
  safeTxHash?: string
  /** Set to true to proceed with the relay when a previous attempt returned INDETERMINATE_SIMULATION. The user has acknowledged the simulation could not be completed and accepts the risk. */
  acceptUnverifiedSimulation?: boolean
}
export type RelayErrorResponse = {
  /** Stable identifier of the error condition. The frontend MUST branch on this value (not on `message`, which is informational and may change). */
  code: 'SIMULATION_FAILED' | 'INDETERMINATE_SIMULATION'
  /** Human-readable description of the error. Informational only; do not parse. */
  message: string
  statusCode: number
}
export type RelayDto = {
  version: string
  to: string
  data: string
  /** Accepted for backward compatibility and validation; not forwarded to the relay provider. */
  gasLimit?: string | null
  /** Safe transaction hash for relay-fee eligibility check */
  safeTxHash?: string
  /** Set to true to proceed with the relay when a previous attempt returned INDETERMINATE_SIMULATION. The user has acknowledged the simulation could not be completed and accepts the risk. */
  acceptUnverifiedSimulation?: boolean
}
export type RelayTaskStatusReceipt = {
  transactionHash: string
}
export type RelayTaskStatus = {
  /** Relay task status code: 100=Pending, 110=Submitted, 200=Included, 400=Rejected, 500=Reverted */
  status: 100 | 110 | 200 | 400 | 500
  /** On-chain receipt. Only present when status is 200 (Included) or 500 (Reverted) */
  receipt?: RelayTaskStatusReceipt
}
export type RelaysRemaining = {
  remaining: number
  limit: number
}
export const {
  useSpaceRelayRelayV1Mutation,
  useRelayRelayV1Mutation,
  useRelayGetTaskStatusV1Query,
  useLazyRelayGetTaskStatusV1Query,
  useRelayGetRelaysRemainingV1Query,
  useLazyRelayGetRelaysRemainingV1Query,
} = injectedRtkApi
